module.exports = __webpack_public_path__ + "static/img/132.7b9272aa.gif";